<form #form="ngForm" class="form">
  <div class="content px-0 px-sm-3">
    <app-page *ngFor="let page of (pages$ | async)"
              [block]="page"
              class="mb-4 elevation-2"
              (click)="start.emit()"></app-page>
  </div>
</form>
